import { render, staticRenderFns } from "./TBankWidget.vue?vue&type=template&id=1d7c7aa2&scoped=true&"
import script from "./TBankWidget.vue?vue&type=script&lang=js&"
export * from "./TBankWidget.vue?vue&type=script&lang=js&"
import style0 from "./TBankWidget.vue?vue&type=style&index=0&id=1d7c7aa2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7c7aa2",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn,QSpinner});
